<template>
    <div class="content flex wrap center vcenter">
        <div class="flex wrap center vcenter">
            <div>
                <h1>404 صفحه یافت نشد!</h1>
                <p>صفحه‌ای که به دنبال آن هستید یافت نشد.</p>
                <div class="flex wrap center vcenter">
                    <button @click.prevent="this.$router.push('/')">بازگشت به صفحه اصلی</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'NotFound',
}
</script>

<style scoped src="../assets/css/components/notfound.css"></style>